import { RetailButton } from "./retail-button";
import { RetailConfigurator } from "./retail-configurator";
import { RetailPersonalization } from "./retail-personalization";
import { RetailPickers } from "./retail-pickers";
import { RetailSize } from "./retail-size";

const install = Vue => {
    Vue.component("retail-button", RetailButton);
    Vue.component("retail-configurator", RetailConfigurator);
    Vue.component("retail-personalization", RetailPersonalization);
    Vue.component("retail-pickers", RetailPickers);
    Vue.component("retail-size", RetailSize);
};

export { RetailButton, RetailConfigurator, RetailPersonalization, RetailPickers, RetailSize };

export default install;
